import io from 'socket.io-client';
import { Application, feathers } from '@feathersjs/feathers';
import socketIO from '@feathersjs/socketio-client';
import auth from '@feathersjs/authentication-client';
import rest from '@feathersjs/rest-client';
import axios from 'axios';
import {
  TFeathersContext,
  TFeathersContextRest,
  TFeathersContextSocket,
} from './types';

let sid = 0;
export function createFeathersSocketClient(
  url?: string
): TFeathersContextSocket {
  sid++;
  // console.log(`Client Socket`, sid, url);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (import.meta.env.MODE === 'development') {
    url = 'https://localhost:3030/';
  } else {
    url = '/'
  }

  const socket: any = url ? io(url) : io();
  // console.log('Socket', sid, socket);

  const client = feathers();

  client.configure(socketIO(socket, { timeout: 30000 }));
  client.configure(
    auth({
      storage: window.localStorage,
      storageKey: 'auth',
    })
  );

  return { client, socket, sid };
}

export function createFeathersRestClient(url?: string): TFeathersContextRest {
  const client: Application = feathers();
  const restClient = url ? rest(url) : rest();
  client.configure(restClient.axios(axios));
  //client.configure(restClient.fetch(window.fetch.bind(window)));

  return { client, rest: restClient };
}

const initialContextState: TFeathersContext = createFeathersRestClient();

export default initialContextState;
